
(function () {

  var QUALITY_MAP = {
   'Oud & Musk': 'Warm, smoky, sensual',
  'Oud & Rose': 'Floral, elegant, timeless',
  'Oud & Vanilla': 'Sweet, creamy, comforting'
  };

  var TARGET_POSITIONS = ['2', '3']; // First Note, Second Note

  function initOption(optionEl) {
    var label = optionEl.querySelector('.ProductForm__Label');
    if (!label) return;

    var currentSpan = label.querySelector('.od-current');
    if (!currentSpan) {
      currentSpan = document.createElement('span');
      currentSpan.className = 'od-current';
      label.appendChild(currentSpan);
    }

    function updateCurrent() {
      var checked = optionEl.querySelector('.SizeSwatch__Radio:checked');
      if (!checked) return;
      var value = checked.value;
      var quality = QUALITY_MAP[value];
      currentSpan.textContent = quality ? quality : value;
    }

    optionEl.querySelectorAll('.SizeSwatch__Radio').forEach(function (input) {
      input.addEventListener('change', updateCurrent);
    });

    updateCurrent();
  }

  function init() {
    document.querySelectorAll('.ProductForm__Option').forEach(function (optionEl) {
      var match = optionEl.querySelector(
        TARGET_POSITIONS.map(function (p) {
          return '.SizeSwatch__Radio[data-option-position="' + p + '"]';
        }).join(',')
      );
      if (match) initOption(optionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function () {
  var SECOND_NOTE_DEFAULT_INDEX = 1; // Oud & Rose

  function forceSecondNoteDefault() {
    if (location.search.indexOf('variant=') !== -1) return; // respect direct variant links

    var secondNoteRadios = document.querySelectorAll('.SizeSwatch__Radio[data-option-position="3"]');
    if (secondNoteRadios.length <= SECOND_NOTE_DEFAULT_INDEX) return;

    var target = secondNoteRadios[SECOND_NOTE_DEFAULT_INDEX];
    if (target.checked) return; // already the default, nothing to do

    secondNoteRadios.forEach(function (r) { r.checked = false; });
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceSecondNoteDefault);
  } else {
    forceSecondNoteDefault();
  }
})();